import React from 'react';
import S from '../../UmbracoForm.styles';
const CheckBoxList = React.forwardRef(({ id, field, dirty, error, random = false, ...otherProps }, ref) => {
    let sortBy = undefined;
    if (random) {
        sortBy = () => {
            return 0.5 - Math.random();
        };
    }
    return (React.createElement(S.Field, { className: error?.message && 'invalid', "data-dirty": dirty, "data-invalid": !!error },
        React.createElement(S.LabelMulti, { as: "span" },
            field.caption,
            field.required ? '*' : null),
        React.createElement("div", null, field.preValues?.sort(sortBy).map((option, index) => (React.createElement(S.ControlLabel, { key: `option-${index}`, htmlFor: `${id ?? field.alias}-${index}` },
            React.createElement("input", { ref: ref, id: `${id ?? field.alias}-${index}`, type: "checkbox", required: field.required, value: option.value, ...otherProps }),
            React.createElement(S.CheckboxLabel, null, option.caption))))),
        field.helpText && React.createElement(S.HelpText, null, field.helpText),
        error && React.createElement(S.Error, null, error.message)));
});
CheckBoxList.displayName = 'CheckBoxList';
export default CheckBoxList;
